import enLang from './entries/en-US';
import itLang from './entries/it_IT';
import esLang from './entries/es_ES';
import frLang from './entries/fr_FR';
import deLang from './entries/de_DE';
import plLang from './entries/pl_PL';
import ptLang from './entries/pt_PT';
import ruLang from './entries/ru_RU';

const AppLocale = {
  en: enLang,
  it: itLang,
  es: esLang,
  fr: frLang,
  de: deLang,
  pl: plLang,
  pt: ptLang,
  ru: ruLang,
};

export default AppLocale;
